import Reveal from "@/components/feature/Reveal";
import SectionHeading from "./SectionHeading";
import { processSteps } from "@/mocks/processSteps";

export default function Process() {
  return (
    <section id="process" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="投稿流程"
            title="从提交线索到对外发布，一共四步"
            description="整个过程中投稿人都不需要露面。我们会尽量把需要你配合的环节压缩到最少，能自己核实的部分绝不打扰你。"
          />
        </Reveal>

        <ol className="mt-10 grid grid-cols-1 gap-6 md:mt-14 md:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {processSteps.map((item, index) => (
            <Reveal key={item.step} delay={index * 80} className="h-full">
              <li className="relative flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
                <span className="font-heading text-4xl font-black leading-none text-primary-200 md:text-5xl">
                  {item.step}
                </span>
                {index < processSteps.length - 1 ? (
                  <span className="absolute right-6 top-9 hidden h-px w-10 bg-background-300 lg:block" aria-hidden="true" />
                ) : null}
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </li>
            </Reveal>
          ))}
        </ol>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col items-start gap-4 rounded-lg border border-secondary-200 bg-secondary-50 p-6 md:flex-row md:items-center md:justify-between md:p-7">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-700">
                <i className="ri-shield-check-line" aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  隐私承诺
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                  联系方式为选填项；涉及身份的信息在发布前一律隐去，未经同意不会对外披露投稿人身份。
                </p>
              </div>
            </div>
            <a
              href="#submit"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-secondary-600 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700"
            >
              现在就投稿
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}